import { DirectSignupFiltersFormType } from 'domains/signupDirect/schemas/filtersSchema';
import { captureException } from '@sentry/react';

/**
 * Single source of truth for determining if a lead can go to split evaluations
 */

/** Global ON/OFF switch */
const SPLIT_EVALS_ENABLED = true;

export const filtersAllowSplitEvaluation = ({
  paymentMethod,
}: {
  paymentMethod?: DirectSignupFiltersFormType['paymentMethod'];
}) => {
  if (!SPLIT_EVALS_ENABLED) {
    return { allowed: false, reason: 'Split evaluations are disabled globally' };
  }

  if (!paymentMethod) {
    return { allowed: false, reason: 'Incomplete form' };
  }

  if (paymentMethod.type === 'otherInsurance') {
    return { allowed: false, reason: `Picked can't find my insurance` };
  }

  if (paymentMethod.type === 'insurance') {
    if (paymentMethod.insuranceData.evaluationOnly) {
      return { allowed: false, reason: 'Evaluation-only insurances are not allowed' };
    }

    if (!paymentMethod.insuranceData.allowSplitEvaluations) {
      return {
        allowed: false,
        reason: `Split evaluations is not allowed for ${paymentMethod.insuranceData.friendlyPayerName}`,
      };
    }

    if (paymentMethod.insuranceData.insuranceType === 'Medicaid') {
      return { allowed: false, reason: 'Medicaid is not allowed' };
    }
    if (paymentMethod.insuranceData.insuranceType === 'Medicare') {
      return { allowed: false, reason: 'Medicare is not allowed' };
    }
    if (paymentMethod.insuranceData.insuranceType === 'Commercial') {
      return { allowed: true, reason: 'Commercial insurance is allowed' };
    }
  }

  if (paymentMethod.type === 'privatePay') {
    return { allowed: true, reason: 'Private pay is allowed' };
  }

  captureException(new Error(`Reached end of filtersAllowSplitEvaluation without a return`), {
    data: JSON.stringify({
      paymentMethod,
    }),
  });
  return { allowed: false, reason: 'Default exclusion reason' };
};
